import React, { useEffect } from "react";
import { bool } from "prop-types";
import { connect, useDispatch } from "react-redux";
import { selectors as onboardingSelectors } from "reducers/onboarding";
import { ResponsiveHeader } from "pages/_components/header";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import { Col } from "react-bootstrap";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";
import { goBack, push } from "connected-react-router";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";

const StepSmsSuccess = ({ isMobile, onboardingWithEnrolledUser }) => {
    const dispatch = useDispatch();

    useEffect(() => {}, [dispatch]);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const onContinue = () => {
        if (onboardingWithEnrolledUser) {
            dispatch(push("/onboarding/stepVerifyUsername"));
        } else {
            dispatch(push("/onboarding/StepScanDocument"));
        }
    };

    return (
        <>
            {isMobile && (
                <ResponsiveHeader
                    ticket
                    id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onClickBack={isMobile && onHeaderBack}
                />
            )}
            <MainContainer>
                {!isMobile && <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} />}
                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText text={i18nUtils.get("", "¡Ya validamos tu celular!")} />
                    </h1>
                </Col>
                <div className="illustration text-center">
                    <Image src="figma/illustrations/onboarding3.svg" className="svg-image logo" />
                </div>
                <div className="box box-border-soft">
                    {" "}
                    {!onboardingWithEnrolledUser && (
                        <CustomText
                            text={i18nUtils.get(
                                "",
                                "Ahora podés continuar hacia el siguiente paso de ingreso de datos biométricos.",
                            )}
                        />
                    )}
                    {onboardingWithEnrolledUser && (
                        <CustomText
                            text={i18nUtils.get(
                                "onboarding.stepVerifySms.success.1",
                                "Ahora te pediremos validar tus credenciales.",
                            )}
                        />
                    )}
                </div>
                <div className="form-actions">
                    <Button bsStyle="primary" label="global.continue" loading={false} onClick={onContinue} />
                </div>
            </MainContainer>
        </>
    );
};

StepSmsSuccess.propTypes = {
    isMobile: bool.isRequired,
    onboardingWithEnrolledUser: bool.isRequired,
};

const mapStateToProps = (state) => ({
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
});

export default connect(mapStateToProps)(StepSmsSuccess);
